export const PERMISSIONS = {
  NONE: "NONE",
  USER: ["USER"],
  ADMIN: ["ADMIN"],
  SUPER_ADMIN: ["SUPER_ADMIN"],
  NO_FINANCIAL: ["NO_FINANCIAL"],
  COMMENTS: ["COMMENTS"],
  ADMIN_TRAINING: ["ADMIN_TRAINING"],
};

// Formation: everyone sees their own path; the manager side needs ADMIN_TRAINING (or Easier Labs
// staff). A company SUPER_ADMIN alone does not get it. UI gating only: the backend
// (api/training_rules.py) enforces it.
export const isTrainingAdmin = (user) =>
  !!user?.is_easier_admin || !!user?.permissions?.includes("ADMIN_TRAINING");

export default function usePermissions() {
  const hasRequiredPermissions = (user, requiredPermissions, defendedPermissions = []) => {
    if (user?.permissions && user.permissions.length > 0) {
      const hasPermissions =
        user.permissions.includes(...PERMISSIONS.SUPER_ADMIN) ||
        user.permissions.includes(...requiredPermissions);

      const isDefended = user.permissions.includes(...defendedPermissions);
      if (isDefended) {
        return false;
      }

      return hasPermissions;
    }
    return false;
  };

  return {
    PERMISSIONS,
    hasRequiredPermissions,
  };
}
